import React from "react"

import { useTranslation } from "react-i18next"

import { Grid } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import { SelectWithSearch } from "../UI/SelectWithSearch"

import styles from "./GraphHeader.module.scss"

export interface GraphHeaderProps {
  title?: string
  tooltipText?: string | React.ReactElement
  range?: number
  selectProps?: {
    options: string[]
    value: string
    setValue: (val: string) => void
  }
  headerMode?: "full" | "select" | "none"
  customHeaderComponent?: React.ReactElement
  gutterBottom?: boolean
  padding?: string
}

export function GraphHeader(props: Readonly<GraphHeaderProps>): React.ReactElement {
  const {
    title,
    range,
    tooltipText,
    selectProps,
    headerMode = "full",
    customHeaderComponent,
    gutterBottom,
    padding,
  } = props

  const { t } = useTranslation(["graphs", "common"])

  return (
    <Grid marginBottom={gutterBottom ? "16px" : "0px"} px={padding ? padding : ""} pt={padding ? padding : ""}>
      {headerMode === "full" ? (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flexWrap={"nowrap"}
          className={`chart-header ${styles.header}`}
        >
          {/* Chart title */}
          <Grid item>
            <Typography variant="h3-bold" tooltip={tooltipText} tooltipVerticalAlign="middle" tooltipIconSize={19}>
              {title}
            </Typography>
          </Grid>

          {/* Date range of the data displayed */}
          {range ? (
            <Grid item>
              <Typography variant="label-bold">
                {!!range && t("GraphHeader.days", { ns: "graphs", count: range })}
              </Typography>
            </Grid>
          ) : customHeaderComponent ? (
            <Grid item width={220}>
              {customHeaderComponent}
            </Grid>
          ) : (
            selectProps && (
              <Grid item width={220}>
                <SelectWithSearch
                  initialValue={selectProps.value}
                  options={[
                    { label: t("GraphHeader.selectLabel", { ns: "graphs" }), value: "", isDisabled: true },
                    ...selectProps.options.map((option) => {
                      return { label: option, value: option }
                    }),
                  ]}
                  searchInputPlaceHolder={t("GraphHeader.searchFeatures", { ns: "graphs" })}
                  fullWidth={true}
                  onSelectMenuItem={(item: { label: string; value: string }) => {
                    selectProps.setValue(item.value)
                  }}
                />
              </Grid>
            )
          )}
        </Grid>
      ) : (
        headerMode === "select" &&
        selectProps && (
          <Grid container item xs={12}>
            <SelectWithSearch
              onSelectMenuItem={(item: { label: string; value: string }) => {
                selectProps.setValue(item.value)
              }}
              initialValue={selectProps.value}
              options={[
                { label: t("GraphHeader.selectLabel", { ns: "graphs" }), value: "", isDisabled: true },
                ...selectProps.options.map((option) => {
                  return { label: option, value: option }
                }),
              ]}
            />
          </Grid>
        )
      )}
    </Grid>
  )
}
